
import { ElForm } from 'element-plus'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => [] as any
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    },
    labelWidth: {
      type: String,
      required: false,
      default: '150px'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const cFormRef = ref(ElForm)
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const fR = ref(props.formRules)
    const submitEmit = () => {
      (cFormRef.value as typeof ElForm).validate((valid: any) => {
        if (valid) {
          context.emit('submit')
        }
      })
    }
    const resetEmit = () => {
      (cFormRef.value as typeof ElForm).resetFields()
      context.emit('reset')
    }
    return {
      t,
      fM,
      fS,
      fR,
      cFormRef,
      submitEmit,
      resetEmit
    }
  }
})
